export const SCHEDULES_SCOPE = Object.freeze({
    ASSET: 'ASSET',
    NOTIFICATION: 'NOTIFICATION',
});

export const SCHEDULES_ACTION = Object.freeze({
    PUBLISH: 'PUBLISH',
    PUSH: 'PUSH',
});
